const theftsPerHourData = [{ hour: '00', thefts: 17 },
  { hour: '01', thefts: 9 },
  { hour: '02', thefts: 3 },
  { hour: '03', thefts: 8 },
  { hour: '04', thefts: 6 },
  { hour: '05', thefts: 1 },
  { hour: '06', thefts: 7 },
  { hour: '07', thefts: 20 },
  { hour: '08', thefts: 42 },
  { hour: '09', thefts: 57 },
  { hour: '10', thefts: 62 },
  { hour: '11', thefts: 74 },
  { hour: '12', thefts: 88 },
  { hour: '13', thefts: 79 },
  { hour: '14', thefts: 98 },
  { hour: '15', thefts: 109 },
  { hour: '16', thefts: 123 },
  { hour: '17', thefts: 114 },
  { hour: '18', thefts: 93 },
  { hour: '19', thefts: 84 },
  { hour: '20', thefts: 61 },
  { hour: '21', thefts: 54 },
  { hour: '22', thefts: 24 },
  { hour: '23', thefts: 29 }];

export default theftsPerHourData;
